module.exports = __webpack_public_path__ + "static/media/no_center.b639573e.svg";